import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HeadingService {
    private _count = 0;

    get count(): number {
        return this._count;
    }

    incrementCounter(): void {
        this._count++;
    }

    decrementCounter(): void {
        if (this._count > 0) this._count--;
    }

    resetCounter(): void {
        this._count = 0;
    }
}
